import { FC, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName, IconPrefix, library } from '@fortawesome/fontawesome-svg-core';
import { IonText } from '@ionic/react';

import {
    faPeopleGroup,
    faShieldHalved,
    faSchoolFlag,
    faHouseChimney,
    faStethoscope,
    faHeartPulse,
    faCloudArrowUp,
    faArrowRightFromBracket,
    faCloudArrowDown,
    faUserDoctor,
    faChalkboardUser,
    faHandHoldingHeart,
    faHospitalUser,
    faLocationDot,
    faEnvelope,
    faPhone,
    faMobileScreen,
    faEllipsis,
    faPenToSquare,
    faTrashCan,
    faPlus,
    faMinus,
    faCopy,
    faCheck,
    faPencil,
    faSearch,
    faClose,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCaretUp,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faClipboardList,
    faBars,
    faGear,
    faArrowRightArrowLeft,
    faArrowRight,
    faArrowLeft,
    faArrowTrendUp,
    faPaperclip,
    faCalendarCirclePlus,
    faEye,
    faQuoteLeft,
    faPeopleArrows,
    faBell,
    faAngleDown,
    faPlay,
    faStar,
    faWaveformLines,
    faMicrophone,
    faKeyboard,
    faFilter,
    faBarsFilter,
    faCalendarDay,
    faPause,
    faStop,
    faThumbtack,
    faArrowUpFromBracket,
    faShareNodes,
    faLock,
    faLockOpen,
    faQrcode
} from '@fortawesome/pro-solid-svg-icons';

import {
    faEnvelope as farEnvelope,
    faLightbulb as farLightbulb,
    faHandsHoldingHeart as farHandsHoldingHeart,
    faHandHoldingHeart as farHandHoldingHeart,
    faPeopleRoof as farPeopleRoof,
    faFileContract as farFileContract,
    faHeart as farHeart,
    faCalendarCirclePlus as farCalendarCirclePlus,
    faClock as farClock,
    faStars as farStars,
    faCircleChevronRight as farCircleChevronRight,
    faCirclePlus as farCirclePlus,
    faFaceSmileBeam as farFaceSmileBeam,
    faFaceSmile as farFaceSmile,
    faFaceMeh as farFaceMeh,
    faFaceFrownSlight as farFaceFrownSlight,
    faFaceDisappointed as farFaceDisappointed,
    faComment as farComment,
    faCommentPlus as farCommentPlus,
    faCommentQuestion as farCommentQuestion,
    faCircleInfo as farCircleInfo,
    faBolt as farBolt,
    faBookBlank as farBookBlank,
    faPaperPlane as farPaperPlane,
    faShare as farShare,
    faLock as farLock,
    faCircleCheck as farCircleCheck,
    faPenToSquare as farPenToSquare,
    faClipboard as farClipboard,
    faListUl as farListUl,
    faImage as farImage,
    faUser as farUser,
    faSort as farSort,
    faCalendarDay as farCalendarDay,
    faPause as farPause,
    faPlay as farPlay,
    faCloudExclamation as farCloudExclamation,
    faTag as farTag,
    faArrowsRepeat as farArrowsRepeat,
    faThumbtack as farThumbtack,
    faDiamond as farDiamond,
    faSquareDashed as farSquareDashed
} from '@fortawesome/pro-regular-svg-icons';

import {
    faStar as falStar,
    faCalendarDay as falCalendarDay
} from '@fortawesome/pro-light-svg-icons';

import {
    faFile as faDuoFile,
    faFilePdf as faDuoFilePdf,
    faFileDoc as faDuoFileDoc,
    faSparkles as faDuoSparkles,
    faSun as faDuoSun,
    faStarShooting as faDuoStarShooting,
    faTrophyStar as faDuoTrophyStar,
    faHandshakeAngle as faDuoHandshakeAngle,
    faFlowerDaffodil as faDuoDaffodil,
    faSnooze as faDuoSnooze,
    faVolcano as faDuoVolcano,
    faChair as faDuoChair,
    faWave as faDuoWave,
    faBatteryQuarter as faDuoBatteryQuarter,
    faRaindrops as faDuoRaindrops,
    faCircleMinus as faDuoCircleMinus,
    faArrowsToCircle as faDuoArrowsToCircle,
    faCrow as faDuoCrow,
    faLeaf as faDuoLeaf,
    faCloudBolt as faDuoCloudBolt,
    faCloudExclamation as faDuoCloudExclamation,
    faCloudArrowUp as faDuoCloudArrowUp,
    faTriangleExclamation as faDuoTriangleExclamation,
    faGavel as faDuoGavel,
    faBed as faDuoBed,
    faClock as faDuoClock,
    faClockEight as faDuoClockEight,
    faAlarmClock as faDuoAlarmClock,
    faDumbbell as faDuoDumbbell,
    faBenchTree as faDuoBenchTree,
    faPeople as faDuoPeople,
    faHotTub as faDuoHotTub,
    faBottleWater as faDuoBottleWater,
    faEggFried as faDuoEggFried,
    faSalad as faDuoSalad,
    faPlateUtensils as faDuoPlateUtensils,
    faCitrus as faDuoCitrus,
    faShower as faDuoShower,
    faKitchenSet as faDuoKitchenSet,
    faCalendarDay as faDuoCalendarDay,
    faCalendarDays as faDuoCalendarDays,
    faPeopleLine as faDuoPeopleLine,
    faMedal as faDuoMedal,
    faPills as faDuoPills,
    faPersonWalking as faDuoPersonWalking,
    faCards as faDuoCards,
    faVacuum as faDuoVacuum,
    faCartShopping as faDuoCartShopping,
    faVanShuttle as faDuoVanShuttle,
    faDiamondExclamation as faDuoDiamondExclamation,
    faHousePersonReturn as faDuoHousePersonReturn,
    faHandHoldingMedical as faDuoHandHoldingMedical,
    faClipboardListCheck as faDuoClipboardListCheck,
    faHospital as faDuoHospital,
    faCirclePlus as faDuoCirclePlus,
    faFileLines as faDuoFileLines,
    faCalendarCirclePlus as faDuoCalendarCirclePlus,
    faFileCirclePlus as faDuoFileCirclePlus,
    faPersonCirclePlus as faDuoPersonCirclePlus,
    faComments as faDuoComments,
    faUser as faDuoUser,
    faBadgeCheck as faDuoBadgeCheck,
    faClapperboardPlay as faDuoClapperboardPlay,
    faCommentPen as faDuoCommentPen,
    faNotebook as faDuoNotebook,
    faFaceSmile as faDuoFaceSmile,
    faFaceSmileBeam as faDuoFaceSmileBeam,
    faFaceFrownSlight as faDuoFaceFrownSlight,
    faFaceMeh as faDuoFaceMeh,
    faFaceDisappointed as faDuoFaceDiappointed,
    faPrescriptionBottle as faDuoPrescriptionBottle,
    faPrescriptionBottleMedical as faDuoPrescriptionBottleMedical,
    faClipboardList as faDuoClipboardList,
    faAddressCard as faDuoAddressCard,
    faPenToSquare as faDuoPenToSquare,
    faSquareDashedCirclePlus as faDuoSquareDashedCirclePlus,
    faGift as faDuoGift,
    faThumbtack as faDuoThumbtack,
    faHandDots as faDuoHandDots,
    faPeopleArrows as faDuoPeopleArrows,
    faLocationDot as faDuoLocationDot
} from '@fortawesome/pro-duotone-svg-icons';

import { IBrandColors, IThemeColor } from './IThemeColor';
import { IReactionCode } from '../community/reactions/ReactionsModel';

library.add(
    faWaveformLines,
    faFilter,
    faBarsFilter,
    faCalendarDay,
    faPeopleGroup,
    faShieldHalved,
    faSchoolFlag,
    faHouseChimney,
    faStethoscope,
    faHeartPulse,
    faCloudArrowUp,
    faArrowRightFromBracket,
    faCloudArrowDown,
    faUserDoctor,
    faChalkboardUser,
    faHandHoldingHeart,
    faHospitalUser,
    faLocationDot,
    faEnvelope,
    farEnvelope,
    faPhone,
    faMobileScreen,
    faPencil,
    faEllipsis,
    faPenToSquare,
    faTrashCan,
    faPlus,
    faMinus,
    faCopy,
    faCheck,
    farLightbulb,
    faSearch,
    faClose,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faCaretUp,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faClipboardList,
    faBars,
    faGear,
    faArrowRightArrowLeft,
    faArrowRight,
    faArrowLeft,
    faArrowTrendUp,
    faPaperclip,
    faArrowUpFromBracket,
    faShareNodes,
    faLock,
    faLockOpen,
    faQrcode,
    farHandsHoldingHeart,
    farHandHoldingHeart,
    farPeopleRoof,
    farFileContract,
    farHeart,
    farCalendarCirclePlus,
    faMicrophone,
    faKeyboard,
    faPause,
    faStop,
    farArrowsRepeat,
    faDuoFile,
    faDuoFilePdf,
    faDuoFileDoc,
    faDuoSparkles,
    faDuoSun,
    faDuoStarShooting,
    faDuoTrophyStar,
    faDuoHandshakeAngle,
    faDuoDaffodil,
    faDuoSnooze,
    faDuoVolcano,
    faDuoChair,
    faDuoWave,
    faDuoBatteryQuarter,
    faDuoRaindrops,
    faDuoCircleMinus,
    faDuoArrowsToCircle,
    faDuoCrow,
    faDuoLeaf,
    faDuoCloudBolt,
    faDuoCloudExclamation,
    faDuoCloudArrowUp,
    faDuoTriangleExclamation,
    faDuoGavel,
    faDuoBed,
    faDuoClock,
    faDuoClockEight,
    faDuoAlarmClock,
    faDuoDumbbell,
    faDuoBenchTree,
    faDuoPeople,
    faDuoHotTub,
    faDuoBottleWater,
    faDuoEggFried,
    faDuoSalad,
    faDuoPlateUtensils,
    faDuoCitrus,
    faDuoShower,
    faDuoKitchenSet,
    faDuoCalendarDay,
    faDuoCalendarDays,
    faDuoPeopleLine,
    faDuoMedal,
    faDuoPills,
    faDuoPersonWalking,
    faDuoCards,
    faDuoVacuum,
    faDuoCartShopping,
    faDuoVanShuttle,
    faDuoDiamondExclamation,
    faDuoHousePersonReturn,
    faDuoHandHoldingMedical,
    faDuoClipboardListCheck,
    faDuoHospital,
    faDuoCirclePlus,
    faDuoFileLines,
    faDuoCalendarCirclePlus,
    faDuoFileCirclePlus,
    faDuoPersonCirclePlus,
    faDuoComments,
    faDuoUser,
    faDuoBadgeCheck,
    faDuoClapperboardPlay,
    faDuoCommentPen,
    faDuoNotebook,
    faDuoFaceSmile,
    faDuoFaceSmileBeam,
    faDuoFaceMeh,
    faDuoFaceFrownSlight,
    faDuoFaceDiappointed,
    faDuoPrescriptionBottle,
    faDuoPrescriptionBottleMedical,
    faDuoClipboardList,
    faDuoAddressCard,
    faDuoPenToSquare,
    faDuoSquareDashedCirclePlus,
    faDuoGift,
    faDuoThumbtack,
    faDuoHandDots,
    faDuoPeopleArrows,
    faDuoLocationDot,
    farThumbtack,
    faThumbtack,
    faCalendarCirclePlus,
    farClock,
    farStars,
    farCircleChevronRight,
    faEye,
    farCirclePlus,
    farFaceSmileBeam,
    farFaceSmile,
    farFaceMeh,
    farFaceFrownSlight,
    farFaceDisappointed,
    farComment,
    farCommentPlus,
    farCommentQuestion,
    farCircleInfo,
    farBolt,
    farBookBlank,
    farPaperPlane,
    faQuoteLeft,
    faPeopleArrows,
    faBell,
    faAngleDown,
    faPlay,
    faStar,
    falStar,
    falCalendarDay,
    farShare,
    farLock,
    farCircleCheck,
    farPenToSquare,
    farClipboard,
    farListUl,
    farImage,
    farUser,
    farSort,
    farCalendarDay,
    farPause,
    farPlay,
    farCloudExclamation,
    farTag,
    farDiamond,
    farSquareDashed
);

export type IIconSize = 'small' | 'medium' | 'large' | 'xlarge';
export type IIconShape = 'round';

interface IIconProps {
    // 'inherit' renders with no Ionic color class so the glyph takes currentColor from its
    // parent (e.g. a tinted type pill that sets an inline color)
    color?: IThemeColor | IBrandColors | 'inherit',
    backgroundColor?: IThemeColor | 'white',
    borderColor?: IThemeColor,
    size?: IIconSize,
    customSize?: number, // size override in px (for edge cases)
    shape?: IIconShape,
    slot?: string;
};

export const InnerhiveSVGIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" fill="var(--ion-color-primary)" viewBox="0 0 25 23">
        <path fillRule="evenodd" d="M17.416.751c.537 0 1.034.287 1.302.752l5.298 9.176a1.504 1.504 0 0 1 0 1.504l-5.298 9.175a1.504 1.504 0 0 1-1.302.752H6.826a1.504 1.504 0 0 1-1.314-.772l-1.465-2.632a1 1 0 0 1 1.748-.973l1.323 2.377h10.011l5.012-8.68-5.012-8.679H7.107L5.72 5.155a1 1 0 0 1-1.732-1l1.531-2.652A1.504 1.504 0 0 1 6.821.751h10.595ZM2.88 8.683a1.005 1.005 0 1 1 1.005-1.74 1.005 1.005 0 0 1-1.005 1.74Zm-.368 5.996a1.005 1.005 0 1 0 1.74 1.005 1.005 1.005 0 0 0-1.74-1.005Z" clipRule="evenodd"/>
        <circle cx="1.373" cy="11.497" r="1.005" transform="rotate(120 1.373 11.497)"/>
    </svg>
);

type IReactionIconTypes = IReactionCode | 'add';
export interface IReactionSVGIconConfig {
    base: ReactNode,
    reacted?: ReactNode
};
export const ReactionSVGIcons: {[key in IReactionIconTypes]: IReactionSVGIconConfig} = {
    'add': {
        base: (
            <svg style={{marginTop: 1, marginRight: -3}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M544 0c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24zM400 288A176 176 0 1 0 48 288a176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM146 332.8c19.1 21.6 46.9 35.2 78 35.2s58.9-13.6 78-35.2c8.8-9.9 23.9-10.9 33.9-2.1s10.9 23.9 2.1 33.9C310.2 396.1 269.4 416 224 416s-86.2-19.9-114-51.5c-8.8-9.9-7.8-25.1 2.1-33.9s25.1-7.8 33.9 2.1z"/>
            </svg>
        )
    },

    'love': {
        base: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/>
            </svg>
        ),
        reacted: (
            <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M47.6 300.4L228.3 469.1C235.8 476.1 245.7 480 256 480C266.3 480 276.2 476.1 283.7 469.1L464.4 300.4C494.8 272.1 512 232.4 512 190.9V185.1C512 115.2 461.5 55.6 392.6 44.1C347 36.5 300.6 51.4 268 84L256 96L244 84C211.4 51.4 165 36.5 119.4 44.1C50.5 55.6 0 115.2 0 185.1V190.9C0 232.4 17.2 272.1 47.6 300.4Z" fill="#EB445A"/>
            </svg>
        )
    },

    'support': {
        base: (
            <svg viewBox="0 0 576 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2644_1660)">
                    <path d="M0 416V480C0 497.7 14.3 512 32 512H192H352.5C381.5 512 409.8 502.7 433.2 485.5L559.8 392.2C570.4 384.4 576.1 372.2 576.1 360C576.1 351.8 573.6 343.4 568.3 336.3C555.2 318.5 530.2 314.7 512.4 327.8L392.6 416H272C263.2 416 256 408.8 256 400C256 391.2 263.2 384 272 384H288H352C369.7 384 384 369.7 384 352C384 334.3 369.7 320 352 320H288H272H193.7C164.6 320 136.4 329.9 113.7 348L68.8 384H32C14.3 384 0 398.3 0 416Z" fill="#4763C7"/>
                    <path d="M163.9 28.9C134.5 58.7 134.5 107.1 163.9 136.9L265.5 240.1C271.7 246.4 279.8 249.5 288 249.5C296.2 249.5 304.3 246.4 310.5 240.1L412.1 136.9C441.5 107.1 441.5 58.7 412.1 28.9C382.7 -0.899952 335.1 -0.899952 305.7 28.9L288 46.9001L270.3 28.9C240.9 -0.899952 193.3 -0.899952 163.9 28.9Z" fill="#EB445A"/>
                </g>
                <defs>
                    <clipPath id="clip0_2644_1660">
                        <rect width="576" height="512" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        )
    },

    'gratitude': {
        base: (
            <svg viewBox="0 0 640 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2644_1651)">
                    <path d="M336 224V342.2C336 400.2 375 450.9 431 465.9L599.7 510.9C602.4 511.6 605.2 512 607.9 512C614.9 512 621.7 509.7 627.4 505.4C635.3 499.3 639.9 490 639.9 480V384C639.9 370.2 631.1 358 618 353.6L538.8 327.2C532.3 325 527.9 318.9 527.9 312V238.5C527.9 222.7 523.2 207.3 514.5 194.1L394.8 14.5C390.1 7.4 383.1 2.7 375.4 0.9C373 0.3 370.5 0 368 0C365.7 0 363.5 0.2 361.2 0.7C357.7 1.5 354.3 2.8 351.2 4.8C343.7 9.4 338.8 16.7 336.9 24.7C335.8 29.3 335.7 34.1 336.8 38.8C337.5 42 338.7 45.1 340.4 48.1L426.8 199.3C430.3 205.3 432.1 212.2 432.1 219.1V304C432.1 312.8 424.9 320 416.1 320C407.3 320 400.1 312.8 400.1 304V224C400.1 206.3 385.8 192 368.1 192C350.4 192 336.1 206.3 336.1 224H336Z" fill="#F2C31A"/>
                    <path d="M278.8 0.700018C282.3 1.50002 285.7 2.80002 288.8 4.80002C296.3 9.40002 301.2 16.7 303.1 24.7C304.2 29.3 304.3 34.1 303.2 38.8C302.5 42 301.3 45.1 299.6 48.1L213.3 199.3C209.8 205.3 208 212.2 208 219.1V304C208 312.8 215.2 320 224 320C232.8 320 240 312.8 240 304V224C240 206.3 254.3 192 272 192C289.7 192 304 206.3 304 224V342.2C304 400.2 265 450.9 209 465.9L40.3 510.9C30.7 513.5 20.4 511.4 12.6 505.4C4.8 499.4 0 489.9 0 480V384C0 370.2 8.8 358 21.9 353.6L101.1 327.2C107.6 325 112 318.9 112 312V238.5C112 222.7 116.7 207.3 125.4 194.1L245.2 14.5C249.8 7.40002 256.9 2.70002 264.6 0.900018C269.2 -0.199982 274 -0.299982 278.7 0.800018L278.8 0.700018Z" fill="#F2C31A"/>
                    <path d="M487 495L599.451 511.203C602.151 511.903 604.951 512.303 607.651 512.303C614.651 512.303 621.451 510.003 627.151 505.703C635.051 499.603 639.651 490.303 639.651 480.303V384.303C639.651 370.503 634.6 352.9 621.5 348.5L568.5 324L487 495Z" fill="#11789D"/>
                    <path d="M152.651 495L40.2 511.203C37.4999 511.903 34.7 512.303 32 512.303C25 512.303 18.2 510.003 12.5 505.703C4.59998 499.603 0 490.303 0 480.303V384.303C0 370.503 5.05139 352.9 18.1514 348.5L71.1514 324L152.651 495Z" fill="#11789D"/>
                </g>
                <defs>
                    <clipPath id="clip0_2644_1651">
                        <rect width="640" height="512" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        )
    },

    'celebrate': {
        base: (
            <svg viewBox="0 0 640 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2666_2410)">
                    <path d="M209 32C209 26.8 211.492 21.8 216.078 18.7C223.455 13.8 233.324 15.8 238.209 23.1L270.109 71.1C274.994 78.5 273 88.4 265.723 93.3C258.445 98.2 248.477 96.2 243.592 88.9L211.692 40.9C209.897 38.2 209 35.1 209 32ZM304.701 16C304.701 7.2 311.879 0 320.651 0C329.424 0 336.601 7.2 336.601 16V80C336.601 88.8 329.424 96 320.651 96C311.879 96 304.701 88.8 304.701 80V16ZM371.193 71.1L403.093 23.1C407.978 15.7 417.847 13.8 425.224 18.7C432.601 23.6 434.495 33.5 429.611 40.9L397.71 88.9C392.826 96.3 382.956 98.2 375.579 93.3C368.203 88.4 366.308 78.5 371.193 71.1Z" fill="#075C42"/>
                    <g clipPath="url(#clip1_2666_2410)">
                        <path d="M327.265 303.641C317.226 315.717 317.622 334.811 328.19 346.358L402.427 427.113C430.894 458.132 468.739 475.415 508.104 475.415H520.785C584.983 475.415 637.029 415.943 637.029 342.585V185.604C637.029 172.245 627.584 161.453 615.893 161.453C604.203 161.453 594.758 172.245 594.758 185.604V270.132C594.758 276.773 590.003 282.207 584.19 282.207C578.378 282.207 573.623 276.773 573.623 270.132V137.302C573.623 123.943 564.178 113.151 552.488 113.151C540.797 113.151 531.352 123.943 531.352 137.302V270.132C531.352 276.773 526.597 282.207 520.785 282.207C514.972 282.207 510.217 276.773 510.217 270.132V113.151C510.217 99.7922 500.772 88.9998 489.082 88.9998C477.391 88.9998 467.947 99.7922 467.947 113.151V270.132C467.947 276.773 463.191 282.207 457.379 282.207C451.567 282.207 446.811 276.773 446.811 270.132V137.302C446.811 123.943 437.366 113.151 425.676 113.151C413.986 113.151 404.541 123.943 404.541 137.302V342.585C404.541 343.717 404.541 344.924 404.607 346.056L364.648 302.585C354.08 291.113 337.37 291.566 327.265 303.641ZM446.811 342.585C446.811 335.943 451.567 330.509 457.379 330.509H462.663H563.055C568.867 330.509 573.623 335.943 573.623 342.585C573.623 349.226 568.867 354.66 563.055 354.66H512.198C524.021 368.773 531.352 387.943 531.352 409V415.038C531.352 421.679 526.597 427.113 520.785 427.113C514.972 427.113 510.217 421.679 510.217 415.038V409C510.217 378.962 488.95 354.66 462.663 354.66H457.379C451.567 354.66 446.811 349.226 446.811 342.585Z" fill="#059669"/>
                        <path d="M457.379 330.509C451.567 330.509 446.811 335.943 446.811 342.585C446.811 349.226 451.567 354.66 457.379 354.66H462.663C488.95 354.66 510.217 378.962 510.217 409V415.038C510.217 421.679 514.973 427.113 520.785 427.113C526.597 427.113 531.352 421.679 531.352 415.038V409C531.352 387.943 524.087 368.773 512.199 354.66H563.055C568.867 354.66 573.623 349.226 573.623 342.585C573.623 335.943 568.867 330.509 563.055 330.509H462.663H457.379Z" fill="#075C42"/>
                    </g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M445.387 452.829C445.657 452.937 445.928 453.043 446.199 453.149V494.942C446.199 504.377 455.141 512 466.209 512H566.261C577.329 512 586.271 504.377 586.271 494.942V452.829H445.387Z" fill="#059669"/>
                    <g clipPath="url(#clip2_2666_2410)">
                        <path d="M312.899 303.641C322.939 315.717 322.542 334.811 311.975 346.358L237.737 427.113C209.271 458.132 171.425 475.415 132.061 475.415H119.38C55.1813 475.415 3.13566 415.943 3.13566 342.585V185.604C3.13566 172.245 12.5805 161.453 24.2709 161.453C35.9614 161.453 45.4062 172.245 45.4062 185.604V270.132C45.4062 276.773 50.1616 282.207 55.9738 282.207C61.786 282.207 66.5415 276.773 66.5415 270.132V137.302C66.5415 123.943 75.9863 113.151 87.6767 113.151C99.3672 113.151 108.812 123.943 108.812 137.302V270.132C108.812 276.773 113.567 282.207 119.38 282.207C125.192 282.207 129.947 276.773 129.947 270.132V113.151C129.947 99.7922 139.392 88.9998 151.083 88.9998C162.773 88.9998 172.218 99.7922 172.218 113.151V270.132C172.218 276.773 176.973 282.207 182.785 282.207C188.598 282.207 193.353 276.773 193.353 270.132V137.302C193.353 123.943 202.798 113.151 214.488 113.151C226.179 113.151 235.624 123.943 235.624 137.302V342.585C235.624 343.717 235.624 344.924 235.558 346.056L275.516 302.585C286.084 291.113 302.794 291.566 312.899 303.641ZM193.353 342.585C193.353 335.943 188.598 330.509 182.785 330.509H177.502H77.1091C71.2969 330.509 66.5415 335.943 66.5415 342.585C66.5415 349.226 71.2969 354.66 77.1091 354.66H127.966C116.143 368.773 108.812 387.943 108.812 409V415.038C108.812 421.679 113.567 427.113 119.38 427.113C125.192 427.113 129.947 421.679 129.947 415.038V409C129.947 378.962 151.215 354.66 177.502 354.66H182.785C188.598 354.66 193.353 349.226 193.353 342.585Z" fill="#059669"/>
                        <path d="M182.785 330.509C188.598 330.509 193.353 335.943 193.353 342.585C193.353 349.226 188.598 354.66 182.785 354.66H177.502C151.215 354.66 129.947 378.962 129.947 409V415.038C129.947 421.679 125.192 427.113 119.38 427.113C113.567 427.113 108.812 421.679 108.812 415.038V409C108.812 387.943 116.077 368.773 127.966 354.66H77.1091C71.2969 354.66 66.5414 349.226 66.5414 342.585C66.5414 335.943 71.2969 330.509 77.1091 330.509H177.502H182.785Z" fill="#075C42"/>
                    </g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M194.777 452.829C194.507 452.937 194.237 453.043 193.965 453.149V494.942C193.965 504.377 185.023 512 173.955 512H73.9036C62.8354 512 53.8933 504.377 53.8933 494.942V452.829H194.777Z" fill="#059669"/>
                </g>
                <defs>
                    <clipPath id="clip0_2666_2410">
                        <rect width="640" height="512" fill="white"/>
                    </clipPath>
                    <clipPath id="clip1_2666_2410">
                        <rect width="338.164" height="386.415" fill="white" transform="translate(320 89)"/>
                    </clipPath>
                    <clipPath id="clip2_2666_2410">
                        <rect width="338.164" height="386.415" fill="white" transform="matrix(-1 0 0 1 320.164 89)"/>
                    </clipPath>
                </defs>
            </svg>
        )
    },

    'happy': {
        base: (
            <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2644_1670)">
                    <circle cx="256" cy="256" r="256" fill="#8F7413"/>
                    <path d="M0 256C0 323.895 26.9714 389.01 74.9807 437.019C122.99 485.029 188.105 512 256 512C323.895 512 389.01 485.029 437.019 437.019C485.029 389.01 512 323.895 512 256C512 188.105 485.029 122.99 437.019 74.9807C389.01 26.9714 323.895 0 256 0C188.105 0 122.99 26.9714 74.9807 74.9807C26.9714 122.99 0 188.105 0 256ZM120 224C120 206.1 126.7 188.4 136.6 175.2C146.4 162.2 160.5 152 176 152C191.5 152 205.6 162.2 215.4 175.2C225.3 188.4 232 206.1 232 224C232 227.4 229.8 230.5 226.5 231.6C223.2 232.7 219.6 231.6 217.6 228.8L217.4 228.5C217.2 228.3 217 228 216.7 227.6C216.1 226.8 215.1 225.6 213.9 224.2C211.4 221.4 207.9 217.6 203.7 213.9C194.9 206.1 184.9 199.9 176 199.9C167.1 199.9 157.1 206.1 148.3 213.9C144.1 217.6 140.6 221.4 138.1 224.2C136.9 225.6 135.9 226.8 135.3 227.6C135 228 134.7 228.3 134.6 228.5L134.4 228.8C132.3 231.6 128.7 232.7 125.5 231.6C122.3 230.5 120 227.5 120 224ZM139.9 346.5C134.1 339.8 134.8 329.7 141.5 323.9C148.2 318.1 158.3 318.8 164.1 325.5C182 346.2 212.6 368 256 368C299.4 368 330 346.2 347.9 325.5C353.7 318.8 363.8 318.1 370.5 323.9C377.2 329.7 377.9 339.8 372.1 346.5C349.8 372.1 311.1 400 256 400C200.9 400 162.2 372.1 139.9 346.5ZM280 224C280 206.1 286.7 188.4 296.6 175.2C306.4 162.2 320.5 152 336 152C351.5 152 365.6 162.2 375.4 175.2C385.3 188.4 392 206.1 392 224C392 227.4 389.8 230.5 386.5 231.6C383.2 232.7 379.6 231.6 377.6 228.8L377.4 228.5C377.2 228.3 377 228 376.7 227.6C376.1 226.8 375.1 225.6 373.9 224.2C371.4 221.4 367.9 217.6 363.7 213.9C354.9 206.1 344.9 199.9 336 199.9C327.1 199.9 317.1 206.1 308.3 213.9C304.1 217.6 300.6 221.4 298.1 224.2C296.9 225.6 295.9 226.8 295.3 227.6C295 228 294.7 228.3 294.6 228.5L294.4 228.8C292.3 231.6 288.7 232.7 285.5 231.6C282.3 230.5 280 227.5 280 224Z" fill="#F2C31A"/>
                    <path d="M217.6 228.8C219.7 231.6 223.3 232.7 226.5 231.6C229.7 230.5 232 227.5 232 224C232 206.1 225.3 188.4 215.4 175.2C205.6 162.2 191.5 152 176 152C160.5 152 146.4 162.2 136.6 175.2C126.7 188.4 120 206.1 120 224C120 227.4 122.2 230.5 125.5 231.6C128.8 232.7 132.4 231.6 134.4 228.8L134.6 228.6C134.8 228.4 135 228.1 135.3 227.7C135.9 226.9 136.9 225.7 138.1 224.3C140.6 221.5 144.1 217.7 148.3 214C157.1 206.2 167.1 200 176 200C184.9 200 194.9 206.2 203.7 214C207.9 217.7 211.4 221.5 213.9 224.3C215.1 225.7 216.1 226.9 216.7 227.7C217 228.1 217.3 228.4 217.4 228.6L217.6 228.8ZM377.6 228.8C379.7 231.6 383.3 232.7 386.5 231.6C389.7 230.5 392 227.5 392 224C392 206.1 385.3 188.4 375.4 175.2C365.6 162.2 351.5 152 336 152C320.5 152 306.4 162.2 296.6 175.2C286.7 188.4 280 206.1 280 224C280 227.4 282.2 230.5 285.5 231.6C288.8 232.7 292.4 231.6 294.4 228.8L294.6 228.6C294.8 228.4 295 228.1 295.3 227.7C295.9 226.9 296.9 225.7 298.1 224.3C300.6 221.5 304.1 217.7 308.3 214C317.1 206.2 327.1 200 336 200C344.9 200 354.9 206.2 363.7 214C367.9 217.7 371.4 221.5 373.9 224.3C375.1 225.7 376.1 226.9 376.7 227.7C377 228.1 377.3 228.4 377.4 228.6L377.6 228.8Z" fill="#8F7413"/>
                </g>
                <defs>
                    <clipPath id="clip0_2644_1670">
                        <rect width="512" height="512" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        )
    },

    'sad': {
        base: (
            <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_2644_1663)">
                    <circle cx="256" cy="256" r="256" fill="#1E717A"/>
                    <path d="M64.4072 215.867L64.3618 215.878C59.9762 207.216 63.6059 196.725 72.2224 192.362L72.2292 192.358L72.2361 192.355C79.8333 188.556 87.4345 184.756 95.1362 180.955C109.43 173.856 121.961 163.599 132.031 151.16C132.032 151.159 132.033 151.158 132.034 151.156L139.229 142.163L146.427 133.165L64.4072 215.867ZM64.4072 215.867C68.7962 224.418 79.2422 228.007 87.8728 223.641C87.8744 223.64 87.876 223.639 87.8776 223.638L110.866 212.244L110.871 212.242C129.663 202.846 146.234 189.509 159.371 173.037L64.4072 215.867ZM159.373 173.035L166.571 164.037L173.771 155.037L173.773 155.035C179.785 147.493 178.588 136.448 171.035 130.427C163.493 124.416 152.45 125.612 146.429 133.163L159.373 173.035ZM97.998 290.497L97.9993 290.499C113.5 311.2 136.757 321.5 160 321.5C183.243 321.5 206.5 311.2 222.001 290.499L222.002 290.497C227.792 282.741 226.268 271.799 218.497 265.998C210.741 260.208 199.799 261.732 193.998 269.503C176.997 292.2 143 292.199 126.001 269.501C120.199 261.732 109.259 260.208 101.503 265.998C93.7318 271.799 92.2077 282.741 97.998 290.497ZM289.998 290.497L289.999 290.499C305.5 311.2 328.757 321.5 352 321.5C375.243 321.5 398.5 311.2 414.001 290.499L414.002 290.497C419.792 282.741 418.268 271.799 410.497 265.998C402.741 260.208 391.801 261.732 385.999 269.501C368.999 292.2 335.001 292.2 318.001 269.501C312.199 261.732 301.259 260.208 293.503 265.998C285.732 271.799 284.208 282.741 289.998 290.497ZM365.671 133.063L365.665 133.056L365.66 133.049C362.175 128.802 357.15 126.5 352 126.5C348.198 126.5 344.252 127.694 341.054 130.336C333.651 136.247 332.364 146.988 338 154.512V154.626L338.329 155.037L345.529 164.037L352.729 173.037L352.734 173.043C365.966 189.406 382.533 202.844 401.329 212.242L401.334 212.244L424.134 223.544L424.136 223.545C432.773 227.809 443.261 224.311 447.634 215.686C448.955 213.151 449.5 210.512 449.5 207.9C449.5 201.563 446.006 195.326 439.871 192.258L439.864 192.255C432.168 188.457 424.571 184.659 416.971 180.858L416.967 180.857C402.662 173.753 390.036 163.593 380.074 151.066L380.071 151.063L365.671 133.063ZM76.0413 435.959C28.3133 388.231 1.5 323.498 1.5 256C1.5 188.502 28.3133 123.769 76.0413 76.0413C123.769 28.3133 188.502 1.5 256 1.5C323.498 1.5 388.231 28.3133 435.959 76.0413C483.687 123.769 510.5 188.502 510.5 256C510.5 323.498 483.687 388.231 435.959 435.959C388.231 483.687 323.498 510.5 256 510.5C188.502 510.5 123.769 483.687 76.0413 435.959ZM208 382.5C198.372 382.5 190.5 390.372 190.5 400C190.5 409.628 198.372 417.5 208 417.5H304C313.628 417.5 321.5 409.628 321.5 400C321.5 390.372 313.628 382.5 304 382.5H208Z" fill="#54C0CC" stroke="#54C0CC" strokeWidth="3"/>
                    <path d="M439.2 193.7C447.1 197.7 450.3 207.3 446.4 215.2C442.5 223.1 432.8 226.3 424.9 222.4L402 210.9C383.4 201.6 367 188.3 353.9 172.1L339.5 154.1C334 147.2 335.1 137.1 342 131.6C348.9 126.1 359 127.2 364.5 134.1L378.9 152.1C389 164.8 401.8 175.1 416.3 182.3L439.2 193.7ZM65.7 215.2C61.7 207.3 65 197.7 72.9 193.7L95.8 182.3C110.3 175.1 123 164.7 133.2 152.1L147.6 134.1C153.1 127.2 163.2 126.1 170.1 131.6C177 137.1 178.1 147.2 172.6 154.1L158.2 172.1C145.2 188.4 128.8 201.6 110.2 210.9L87.2 222.3C79.3 226.3 69.7 223 65.7 215.1V215.2ZM124.8 270.4C142.4 293.9 177.6 293.9 195.2 270.4C200.5 263.3 210.5 261.9 217.6 267.2C224.7 272.5 226.1 282.5 220.8 289.6C190.4 330.1 129.6 330.1 99.2 289.6C93.9 282.5 95.3 272.5 102.4 267.2C109.5 261.9 119.5 263.3 124.8 270.4ZM316.8 270.4C334.4 293.9 369.6 293.9 387.2 270.4C392.5 263.3 402.5 261.9 409.6 267.2C416.7 272.5 418.1 282.5 412.8 289.6C382.4 330.1 321.6 330.1 291.2 289.6C285.9 282.5 287.3 272.5 294.4 267.2C301.5 261.9 311.5 263.3 316.8 270.4Z" fill="#1E717A"/>
                </g>
                <defs>
                    <clipPath id="clip0_2644_1663">
                        <rect width="512" height="512" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        )
    },

    // TODO: 'notification-sent:email' really shouldn't be here. See ReactionsModel...
    'notification-sent:email': {
        base: '',
        reacted: ''
    }
};

export const CommentPlusSVGIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"/>
    </svg>
);

const Icon: FC<IIconProps & { name: IconName, prefix: IconPrefix }> = ({
    name,
    prefix,
    color = 'primary',
    backgroundColor,
    borderColor,
    size = 'medium',
    customSize,
    shape,
    slot
}) => {
    let fontSize = customSize || {small: 14, medium: 18, large: 24, xlarge: 32}[size];

    let wrapperStyle: React.CSSProperties = {};

    if (shape === 'round') {
        if (customSize) {
            throw new Error('customSize not supported with shape round');
        }

        wrapperStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: {small: '1.5em', medium: '2em', large: '2.5em', xlarge: '3em'}[size],
            height: {small: '1.5em', medium: '2em', large: '2.5em', xlarge: '3em'}[size],
            backgroundColor: backgroundColor === 'white' ? 'white' : backgroundColor ? `var(--ion-color-${backgroundColor})` : `rgb(var(--ion-color-${color}-rgb), 0.2)`,
            boxShadow: borderColor ? `0 0 1px 1px var(--ion-color-${borderColor})` : undefined,
            borderRadius: '50%'
        };

        // reduce size slightly so it fits nicely in the circle
        fontSize = fontSize * (size === 'small' ? 0.85 : 0.75);

        return (
            <div style={wrapperStyle} slot={slot || ''}>
                <IonText color={color} style={{fontSize}}>
                    <FontAwesomeIcon icon={[prefix, name]} />
                </IonText>
            </div>
        );
    }

    return (
        <IonText color={color === 'inherit' ? undefined : color} style={{fontSize}} slot={slot || ''}>
            <FontAwesomeIcon icon={[prefix, name]} />
        </IonText>
    );
};

export type IconComponent = FC<IIconProps>;

const buildIcon = (name: IconName, prefix: IconPrefix = 'fas'): IconComponent => {
    return (props: IIconProps) => <Icon name={name} prefix={prefix} {...props} />;
};

export const LogoutIcon = buildIcon('arrow-right-from-bracket');
export const LocationIcon = buildIcon('location-dot');
export const EnvelopeIcon = buildIcon('envelope');
export const EnvelopeOutlineIcon = buildIcon('envelope', 'far');
export const BellIcon = buildIcon('bell');
export const CopyIcon = buildIcon('copy');
export const CheckIcon = buildIcon('check');
export const PhoneIcon = buildIcon('phone');
export const MobilePhoneIcon = buildIcon('mobile-screen');
export const MoreIcon = buildIcon('ellipsis');
export const EditIcon = buildIcon('pen-to-square');
export const EditIcon2 = buildIcon('pencil');
export const DeleteIcon = buildIcon('trash-can');
export const ShareIcon = buildIcon('share', 'far');
export const ShareNodesIcon = buildIcon('share-nodes');
export const QrCodeIcon = buildIcon('qrcode');
export const ArrowUpFromBracketIcon = buildIcon('arrow-up-from-bracket');
export const DownloadIcon = buildIcon('cloud-arrow-down');
export const UploadIcon = buildIcon('cloud-arrow-up');
export const CloudUpIcon = buildIcon('cloud-arrow-up');
export const PlusIcon = buildIcon('plus');
export const MinusIcon = buildIcon('minus');
export const LightbulbOutlineIcon = buildIcon('lightbulb', 'far');
export const SearchIcon = buildIcon('search');
export const BackIcon = buildIcon('chevron-left');
export const CloseIcon = buildIcon('close');
export const ClipboardListIcon = buildIcon('clipboard-list');
export const HamburgerMenuIcon = buildIcon('bars');
export const GearIcon = buildIcon('gear');
export const ArrowRightArrowLeftIcon = buildIcon('arrow-right-arrow-left');
export const ArrowRightIcon = buildIcon('arrow-right');
export const ArrowLeftIcon = buildIcon('arrow-left');
export const ArrowTrendUpIcon = buildIcon('arrow-trend-up');
export const RepeatIcon = buildIcon('arrows-repeat', 'far');
export const ChevronUpIcon = buildIcon('chevron-up');
export const ChevronDownIcon = buildIcon('chevron-down');
export const ChevronRightIcon = buildIcon('chevron-right');
export const ChevronLeftIcon = buildIcon('chevron-left');
export const CaretUpIcon = buildIcon('caret-up');
export const CaretDownIcon = buildIcon('caret-down');
export const CaretLeftIcon = buildIcon('caret-left');
export const CaretRightIcon = buildIcon('caret-right');
export const CircleChevronRightIcon = buildIcon('circle-chevron-right', 'far');
export const PaperclipIcon = buildIcon('paperclip');
export const AddAppointmentIcon = buildIcon('calendar-circle-plus');
export const ClockOutlineIcon = buildIcon('clock', 'far');
export const EyeIcon = buildIcon('eye');
export const LeftQuoteIcon = buildIcon('quote-left');
export const PeopleArrowsIcon = buildIcon('people-arrows');
export const DuoFileLinesIcon = buildIcon('file-lines', 'fad');
export const AngleDownIcon = buildIcon('angle-down');
export const CommentIcon = buildIcon('comment', 'far');
export const CommentPlusIcon = buildIcon('comment-plus', 'far');
export const CommentQuestionIcon = buildIcon('comment-question', 'far');
export const InfoIcon = buildIcon('circle-info', 'far');
export const PaperPlaneIcon = buildIcon('paper-plane', 'far');
export const StreakIcon = buildIcon('bolt', 'far');
export const JournalIcon = buildIcon('book-blank', 'far');
export const StarIcon = buildIcon('star');
export const TagIcon = buildIcon('tag', 'far');
export const SortIcon = buildIcon('sort', 'far');
export const FilterIcon = buildIcon('bars-filter');
export const StarOutlineIcon = buildIcon('star', 'fal');
export const PlayIcon = buildIcon('play');
export const WaveformLinesIcon = buildIcon('waveform-lines');
export const MicrophoneIcon = buildIcon('microphone');
export const KeyboardIcon = buildIcon('keyboard');
export const LockIcon = buildIcon('lock', 'far');
export const LockSolidIcon = buildIcon('lock');
export const UnlockSolidIcon = buildIcon('lock-open');
export const CloudExclamationIcon = buildIcon('cloud-exclamation', 'far');
export const CircleCheckIcon = buildIcon('circle-check', 'far');
export const PenToSquareIcon = buildIcon('pen-to-square', 'far');
export const ClipboardIcon = buildIcon('clipboard', 'far');
export const ListUlIcon = buildIcon('list-ul', 'far');
export const ImageIcon = buildIcon('image', 'far');
export const UserIcon = buildIcon('user', 'far');
export const CalendarDayIcon = buildIcon('calendar-day', 'fal');
export const CalendarDayRegularIcon = buildIcon('calendar-day', 'far');
export const PauseIcon = buildIcon('pause');
export const PauseRegularIcon = buildIcon('pause', 'far');
export const StopIcon = buildIcon('stop');
export const PlayRegularIcon = buildIcon('play', 'far');

// support groups
export const SchoolGroupIcon = buildIcon('school-flag');
export const MedicalGroupIcon = buildIcon('stethoscope');
export const CommunityGroupIcon = buildIcon('people-group');
export const SpecialistsGroupIcon = buildIcon('heart-pulse');
export const FinancialGroupIcon = buildIcon('shield-halved');
export const SocialGroupIcon = buildIcon('house-chimney');

// support group members
export const SchoolMemberIcon = buildIcon('chalkboard-user');
export const MedicalMemberIcon = buildIcon('user-doctor');
export const CommunityMemberIcon = buildIcon('hand-holding-heart');
export const SpecialistsMemberIcon = buildIcon('hospital-user');
export const FinancialMemberIcon = buildIcon('shield-halved');
export const SocialMemberIcon = buildIcon('house-chimney');

// doc types
export const DuoFileIcon = buildIcon('file', 'fad');
export const DuoPDFFileIcon = buildIcon('file-pdf', 'fad');
export const DuoDocFileIcon = buildIcon('file-doc', 'fad');
export const DuoClapperboardPlayIcon = buildIcon('clapperboard-play', 'fad');

// innerhive plus
export const InnerhivePlusIcon: React.FC<IIconProps> = ({ color = 'secondary', size }) => (
    <IonText color={color} style={{fontSize: size === 'large' ? 24 : 18}}>
        <svg className="svg-inline--fa" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4049_6955)">
                <path opacity="0.4" d="M7.5 85.2L64 64L85.2 7.5C86.9 3 91.2 0 96 0C100.8 0 105.1 3 106.8 7.5L128 64L184.5 85.2C189 86.9 192 91.2 192 96C192 100.8 189 105.1 184.5 106.8L128 128L106.8 184.5C105.1 189 100.8 192 96 192C91.2 192 86.9 189 85.2 184.5L64 128L7.5 106.8C3 105.1 0 100.8 0 96C0 91.2 3 86.9 7.5 85.2ZM7.5 405.2L64 384L85.2 327.5C86.9 323 91.2 320 96 320C100.8 320 105.1 323 106.8 327.5L128 384L184.5 405.2C189 406.9 192 411.2 192 416C192 420.8 189 425.1 184.5 426.8L128 448L106.8 504.5C105.1 509 100.8 512 96 512C91.2 512 86.9 509 85.2 504.5L64 448L7.5 426.8C3 425.1 0 420.8 0 416C0 411.2 3 406.9 7.5 405.2Z" fill="currentColor"/>
                <path d="M351.231 95.2308C351.231 79.0625 338.168 66 322 66C305.832 66 292.769 79.0625 292.769 95.2308V226.769H161.231C145.062 226.769 132 239.832 132 256C132 272.168 145.062 285.231 161.231 285.231H292.769V416.769C292.769 432.937 305.832 446 322 446C338.168 446 351.231 432.937 351.231 416.769V285.231H482.769C498.937 285.231 512 272.168 512 256C512 239.832 498.937 226.769 482.769 226.769H351.231V95.2308Z" fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_4049_6955">
                    <rect width="512" height="512" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </IonText>
);

export const AIIcon = buildIcon('sparkles', 'fad');
export const ShareCareIcon = buildIcon('hands-holding-heart', 'far');
export const ImproveCareIcon = buildIcon('people-roof', 'far');
export const UnlimitedStorageIcon = buildIcon('file-contract', 'far');
export const SupportInnerhiveIcon = buildIcon('heart', 'far');
export const StarsIcon = buildIcon('stars', 'far');
export const CalendarPlusIcon = buildIcon('calendar-circle-plus', 'far');

// caregiver
export const AddFeelingIcon = buildIcon('circle-plus', 'fad');
export const DuoSquareDashedCirclePlusIcon = buildIcon('square-dashed-circle-plus', 'fad');
export const SquareDashedIcon = buildIcon('square-dashed', 'far');
export const VeryHappyIcon = buildIcon('face-smile-beam', 'far');
export const HappyIcon = buildIcon('face-smile', 'far');
export const MehIcon = buildIcon('face-meh', 'far');
export const SadIcon = buildIcon('face-frown-slight', 'far');
export const VerySadIcon = buildIcon('face-disappointed', 'far');
export const CaregiverIcon = buildIcon('hand-holding-heart', 'far');

export const DuoSunIcon = buildIcon('sun', 'fad');
export const DuoShootingStarIcon = buildIcon('star-shooting', 'fad');
export const DiamondOutlineIcon = buildIcon('diamond', 'far');
export const DuoTrophyStarIcon = buildIcon('trophy-star', 'fad');
export const DuoHandshakeIcon = buildIcon('handshake-angle', 'fad');
export const DuoDaffodilIcon = buildIcon('flower-daffodil', 'fad');
export const DuoSnoozeIcon = buildIcon('snooze', 'fad');
export const DuoVolvanoIcon = buildIcon('volcano', 'fad');
export const DuoChairIcon = buildIcon('chair', 'fad');
export const DuoWaveIcon = buildIcon('wave', 'fad');
export const DuoBatteryQuarterIcon = buildIcon('battery-quarter', 'fad');
export const DuoRaindropsIcon = buildIcon('raindrops', 'fad');
export const DuoCircleMinusIcon = buildIcon('circle-minus', 'fad');
export const DuoArrowsToCircleIcon = buildIcon('arrows-to-circle', 'fad');
export const DuoCrowIcon = buildIcon('crow', 'fad');
export const DuoLeafIcon = buildIcon('leaf', 'fad');
export const DuoCloudBoltIcon = buildIcon('cloud-bolt', 'fad');
export const DuoCloudExclamationIcon = buildIcon('cloud-exclamation', 'fad');
export const DuoCloudArrowUpIcon = buildIcon('cloud-arrow-up', 'fad');
export const DuoTriangleExclamationIcon = buildIcon('triangle-exclamation', 'fad');
export const DuoGavelIcon = buildIcon('gavel', 'fad');
export const DuoBedIcon = buildIcon('bed', 'fad');
export const DuoClockIcon = buildIcon('clock', 'fad');
export const DuoClockEightIcon = buildIcon('clock-eight', 'fad');
export const DuoAlarmClockIcon = buildIcon('alarm-clock', 'fad');
export const DuoDumbbellIcon = buildIcon('dumbbell', 'fad');
export const DuoBenchTreeIcon = buildIcon('bench-tree', 'fad');
export const DuoPeopleIcon = buildIcon('people', 'fad');
export const DuoHotTubIcon = buildIcon('hot-tub', 'fad');
export const DuoBottleWaterIcon = buildIcon('bottle-water', 'fad');
export const DuoEggFriedIcon = buildIcon('egg-fried', 'fad');
export const DuoSaladIcon = buildIcon('salad', 'fad');
export const DuoPlateUtensilsIcon = buildIcon('plate-utensils', 'fad');
export const DuoCitrusIcon = buildIcon('citrus', 'fad');
export const DuoShowerIcon = buildIcon('shower', 'fad');
export const DuoKitchenSetIcon = buildIcon('kitchen-set', 'fad');
export const DuoCalendarDayIcon = buildIcon('calendar-day', 'fad');
export const DuoCalendarDaysIcon = buildIcon('calendar-days', 'fad');
export const DuoPeopleLineIcon = buildIcon('people-line', 'fad');
export const DuoMedalIcon = buildIcon('medal', 'fad');
export const DuoPillsIcon = buildIcon('pills', 'fad');
export const DuoPersonWalkingIcon = buildIcon('person-walking', 'fad');
export const DuoCardsIcon = buildIcon('cards', 'fad');
export const DuoVacuumIcon = buildIcon('vacuum', 'fad');
export const DuoCartShoppingIcon = buildIcon('cart-shopping', 'fad');
export const DuoVanShuttleIcon = buildIcon('van-shuttle', 'fad');
export const DuoDiamondExclamationIcon = buildIcon('diamond-exclamation', 'fad');
export const DuoHousePersonReturnIcon = buildIcon('house-person-return', 'fad');
export const DuoHandHoldingMedicalIcon = buildIcon('hand-holding-medical', 'fad');
export const DuoClipboardListCheckIcon = buildIcon('clipboard-list-check', 'fad');
export const DuoHospitalIcon = buildIcon('hospital', 'fad');
export const DuoCalendarPlusIcon = buildIcon('calendar-circle-plus', 'fad');
export const DuoCalendarIcon = buildIcon('calendar-days', 'fad');
export const DuoFilePlusIcon = buildIcon('file-circle-plus', 'fad');
export const DuoPersonCirlcePlusIcon = buildIcon('person-circle-plus', 'fad');
export const DuoCommentsIcon = buildIcon('comments', 'fad');
export const DuoCommentPenIcon = buildIcon('comment-pen', 'fad');
export const DuoNotebookIcon = buildIcon('notebook', 'fad');
export const DuoUserIcon = buildIcon('user', 'fad');
export const DuoBadgeCheckIcon = buildIcon('badge-check', 'fad');
export const DuoHappyIcon = buildIcon('face-smile', 'fad');
export const DuoVeryHappyIcon = buildIcon('face-smile-beam', 'fad');
export const DuoMehIcon = buildIcon('face-meh', 'fad');
export const DuoSadIcon = buildIcon('face-frown-slight', 'fad');
export const DuoVerySadIcon = buildIcon('face-disappointed', 'fad');
export const DuoPrescriptionBottleMedicalIcon = buildIcon('prescription-bottle-medical', 'fad');
export const DuoClipboardListIcon = buildIcon('clipboard-list', 'fad');
export const DuoHandDotsIcon = buildIcon('hand-dots', 'fad');
export const DuoPrescriptionBottleIcon = buildIcon('prescription-bottle', 'fad');
export const DuoPeopleArrowsIcon = buildIcon('people-arrows', 'fad');
export const DuoLocationDotIcon = buildIcon('location-dot', 'fad');
export const DuoAddressCardIcon = buildIcon('address-card', 'fad');
export const DuoEditIcon = buildIcon('pen-to-square', 'fad');
export const DuoGiftIcon = buildIcon('gift', 'fad');

// note pins
export const ThumbtackIcon = buildIcon('thumbtack');
